import { eventWorkspaceChanged } from './cam-context-switcher-constants';
import camContextSwitcherDatastore from './cam-context-switcher-datastore';
import CamContextSwitcherWorkspace from './cam-context-switcher-workspace';

const tagName = 'cam-context-switcher-workspace-list';
const template = require(`../templates/${tagName}.ejs`);

export default class CamContextSwitcherWorkspaceList extends HTMLElement {

  static get observedAttributes() {
    return [ 'selected-organization', 'selected-costcenter' ];
  }

  constructor() {
    super();
    this.datastore = camContextSwitcherDatastore;
  }

  connectedCallback() {
    this.classList.add(tagName);

    this.addEventListener(eventWorkspaceChanged, this.handleWorkspaceChange);

    this.innerHTML = template();
    this.container = this.querySelector('.content-wrapper');
  }

  disconnectedCallback() {
    this.removeEventListener(eventWorkspaceChanged, this.handleWorkspaceChange);
  }

  attributeChangedCallback(attrName, oldValue, newValue) {
    if (newValue !== oldValue) {
      this.renderCamWorkspaceList(this.datastore.workspaces);
    }
  }

  renderCamWorkspaceList(workspaceList) {
    while (this.container.firstChild) {
      this.container.removeChild(this.container.firstChild);
    }
    workspaceList.forEach((ws) => {
      let workspaceElement = new CamContextSwitcherWorkspace(ws);
      this.container.appendChild(workspaceElement);
    });
  }

  handleWorkspaceChange(e) {
    e.cancelBubble = true;

    this.datastore.changeWorkspace(e.detail.workspace.id, true);

    this.renderCamWorkspaceList(this.datastore.workspaces);

  }


}

customElements.define(tagName, CamContextSwitcherWorkspaceList);



// WEBPACK FOOTER //
// ./src/cam-context-switcher/scripts/cam-context-switcher-workspace-list.js